// extracted by mini-css-extract-plugin
module.exports = {"container":"Wedding_container__ESB5Z","img":"Wedding_img__X-aP6"};